import { styled } from '@magal/styles'

export const Rule = styled('hr', {
  border: 'none',
  borderTop: '1px solid $green_09',
  margin: 0,
})
